import script from "./DropdownChildMenuItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./DropdownChildMenuItem.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__